import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Drawer,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Image from 'next/image';
import CloseIcon from '@mui/icons-material/Close';

import {
  filtersStateVar,
  updateFilterSelection,
  usePersistentFilterSelection,
} from 'store/filter';
import theme from 'src/style-system/theme';

import Accordion from '@components/Accordian';
import CuminButton from '@components/Button';
import { allFiltersType } from '@utils/types';
import SpiceLevel from '../SpiceLevel';

import { useStyles } from './useStyles';

interface FilterDrawerProps {
  filterData: allFiltersType[];
  setOpen: (isOpen: boolean) => void;
  open: boolean;
  isFullScreen?: boolean;
  isPantryFilter?: boolean;
}

const FilterDrawer = ({
  setOpen,
  open,
  isFullScreen,
  filterData,
  isPantryFilter,
}: FilterDrawerProps) => {
  const filterSelect = usePersistentFilterSelection();
  const handleDrawerClose = () => {
    setOpen(false);
    window.scroll(0, 0);
  };

  const classes = useStyles();

  const handleChange = (
    filterId: number,
    filterGroupName: string,
    filterLabel: string
  ) => {
    if (filterSelect[filterId]?.isSelected) {
      updateFilterSelection(filterId, false, filterGroupName, filterLabel);
    } else {
      updateFilterSelection(filterId, true, filterGroupName, filterLabel);
    }
  };

  const handleClearFilter = () => {
    filtersStateVar({});
  };

  return (
    <>
      <Drawer
        className={classes.drawer}
        sx={{
          '& .MuiDrawer-paper': {
            marginTop: isFullScreen ? '0px' : '75px',
          },
        }}
        variant="persistent"
        anchor="top"
        open={open}
      >
        <Box className={classes.mainContainer}>
          <Box className={classes.iconTiltleClearWrapper}>
            <Typography
              variant="body2"
              color="cinnamon.main"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={handleClearFilter}
            >
              Clear
            </Typography>

            <Typography variant="body1" color="cinnamon.main">
              {isPantryFilter ? 'Pantry Filters' : 'Meal Filters'}
            </Typography>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon fontSize="large" sx={{ color: 'cinnamon.main' }} />
            </IconButton>
          </Box>
          <Box>
            {filterData?.map((item) => (
              <Accordion
                bgcolor={theme.palette.whitePepper.main}
                bordercolor={theme.palette.cumin.main}
                marginbottom={15}
                key={item.filter_group_id}
              >
                <AccordionSummary
                  expandIcon={
                    <ArrowDropDownIcon
                      fontSize="large"
                      sx={{ color: 'garamMasala.main' }}
                    />
                  }
                  aria-controls="panel1a-content"
                >
                  <Typography
                    variant="body1"
                    align="left"
                    color="cinnamon.main"
                  >
                    {item.filter_group_label}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {item.filters.map((filter) => (
                    <Box
                      key={filter.id}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onChange={() =>
                          handleChange(
                            filter.id,
                            item.filter_group_name,
                            filter.label
                          )
                        }
                        checked={filterSelect[filter.id]?.isSelected || false}
                        sx={{
                          color: 'white',
                          '&.Mui-checked': {
                            color: 'white',
                          },
                        }}
                      />
                      <Box>
                        <Typography
                          variant="caption"
                          align="left"
                          color="cumin.main"
                        >
                          {filter.label}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
        <Box className={classes.applyFilterBtnWrapper}>
          <CuminButton
            color="cinnamon"
            variant="contained"
            textColor="whitePepper.main"
            borderRadius="24"
            //width="100%"
            height="48"
            fontVariant="button1"
            onClick={handleDrawerClose}
          >
            Apply Filters
          </CuminButton>
        </Box>
      </Drawer>
    </>
  );
};

export default FilterDrawer;
